var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { CharacterCounter } from '../CharacterCounter';
import { ErrorNotification } from '../ErrorNotification';
import { ContextualHelpNotification } from '../ContextualHelpNotification';
import { formTextBackgroundStyles, useFormTextStateProps, } from '../FormText/context';
import { useFormFieldHelper } from './useFormFieldHelper';
var StyledHelpersWrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var StyledNotificationWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var StyledCounterWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var $variant = _a.$variant;
    return "\n    position: absolute;\n    top: ".concat($variant === 'input' ? '-36px' : '-28px', ";\n    padding: 1px;\n    border-radius: 1px;\n  ");
}, function (_a) {
    var $align = _a.$align, space = _a.theme.space;
    if ($align === 'right') {
        return "\n        right: 0;\n        margin-right: ".concat(space.xs, ";\n      ");
    }
    if ($align === 'left') {
        return "\n        left: 0;\n        margin-left: ".concat(space.xs, ";\n    ");
    }
    return '';
}, formTextBackgroundStyles);
var StyledCharacterCounter = styled(CharacterCounter)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var $isDisabled = _a.$isDisabled, colors = _a.theme.colors;
    return "\n    color: ".concat(colors['slate-5'], ";\n    ").concat($isDisabled ? "color: ".concat(colors['periwinkle-500'], ";") : '', "\n    ").concat($isDisabled ? 'cursor: not-allowed;' : '', "\n  ");
});
var FormFieldHelper = function (_a) {
    var nativeDescribedBy = _a.nativeDescribedBy, errorNotification = _a.errorNotification, contextualHelp = _a.contextualHelp, characterCounter = _a.characterCounter, onDescribedByChange = _a.onDescribedByChange, onDescribedByTextChange = _a.onDescribedByTextChange, others = __rest(_a, ["nativeDescribedBy", "errorNotification", "contextualHelp", "characterCounter", "onDescribedByChange", "onDescribedByTextChange"]);
    var _b = useFormFieldHelper({
        nativeDescribedBy: nativeDescribedBy,
        errorNotification: errorNotification,
        contextualHelp: contextualHelp,
        characterCounter: characterCounter,
        onDescribedByChange: onDescribedByChange,
        onDescribedByTextChange: onDescribedByTextChange,
    }), displayError = _b.displayError, displaySrError = _b.displaySrError, displayHelpContent = _b.displayHelpContent, displayCounter = _b.displayCounter, errorMessageId = _b.errorMessageId, srErrorMessageId = _b.srErrorMessageId, helpContentId = _b.helpContentId, charCounterId = _b.charCounterId;
    var _c = useFormTextStateProps({
        suppressWarning: true,
    }), $isDisabled = _c.$isDisabled, $isHovered = _c.$isHovered;
    if (!displayError && !displayHelpContent && !displayCounter) {
        return null;
    }
    return (React.createElement(StyledHelpersWrapper, __assign({}, others),
        displayError && (React.createElement(StyledNotificationWrapper, null,
            React.createElement(ErrorNotification, __assign({ id: errorMessageId, errorMessage: errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message }, (displaySrError
                ? {
                    screenReaderErrorId: srErrorMessageId,
                    screenReaderErrorMessage: errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.srMessage,
                }
                : {}))))),
        !!contextualHelp && displayHelpContent && (React.createElement(StyledNotificationWrapper, null,
            React.createElement(ContextualHelpNotification, { id: helpContentId, content: contextualHelp.content }))),
        displayCounter && (React.createElement(StyledCounterWrapper, { "$variant": (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.variant) || 'textarea', "$align": (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.align) || 'right', "$isHovered": $isHovered || false, "$isDisabled": $isDisabled || false, ref: characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.ref },
            React.createElement(StyledCharacterCounter, { id: charCounterId, charCount: (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.charCount) || 0, maxLength: (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.maxChars) || 0, hideAppendedText: true, "$isDisabled": $isDisabled || false })))));
};
export { FormFieldHelper };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=FormFieldHelper.js.map